import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import {
	deleteLayoutInLocal,
	formatDataAsOrginalLayout,
	getFormattedLayout,
	getLayoutFromLocal,
	sortLayout
} from '../../utils/helper';
import { IHomePageLayoutOrder, IVersionBasedHomePageLayout, IViewHomePageLayoutOrder } from '../../utils/model';

const useLayout = () => {
	const [globalForceUpdate, setGlobalForceUpdate] = useState<boolean>(false);
	const location = useLocation();
	const getLayoutData = () => {
		const parentRowData: IVersionBasedHomePageLayout = _get(location, ['state', 'rowData']);
		const layouts: IHomePageLayoutOrder[] = getLayoutFromLocal(parentRowData);
		const layoutOrderList: IViewHomePageLayoutOrder[] = [];

		layouts.forEach((layout: IHomePageLayoutOrder) => {
			const formattedLayout: IViewHomePageLayoutOrder = getFormattedLayout(layout);
			layoutOrderList.push(formattedLayout);
		});

		sortLayout(layoutOrderList);

		return {
			rowCount: layoutOrderList.length,
			data: layoutOrderList
		};
	};

	const turnGlobalForceUpdateOff = async () => {
		setGlobalForceUpdate(false);
	};

	const removeLayout = (parentRowData: IVersionBasedHomePageLayout, rowData: IViewHomePageLayoutOrder, showAlertParam: any) => {
		try {
			deleteLayoutInLocal(parentRowData, formatDataAsOrginalLayout(rowData));
			setGlobalForceUpdate(true);
			showAlertParam(`${rowData.placeholderFor} is removed from the config`);
		} catch (error: any) {
			showAlertParam(error.response.data.error || 'Error occured while updated', { type: 'error' });
		}
	};

	return { getLayoutData, turnGlobalForceUpdateOff, globalForceUpdate, removeLayout };
};

export default useLayout;
